import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { style: {"margin-top":"15px","margin-right":"69px"} }
const _hoisted_2 = { class: "heading" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Toggle = _resolveComponent("Toggle")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("a", _hoisted_2, _toDisplayString(_ctx.heading), 1),
    _createVNode(_component_Toggle, {
      color: "#0054a6",
      labels: _ctx.label,
      modelValue: _ctx.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.value) = $event)),
      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.changeLink(_ctx.value))),
      style: {"opacity":"0"}
    }, null, 8, ["labels", "modelValue"])
  ]))
}